export const CHOSEN_OPTIONS = {
  disable_search_threshold: 10,
  inherit_select_classes  : true,
  placeholder_text_single : ' '
};
